import React, { useEffect, useState } from 'react';

const sponsors = [
  { id: 's1', name: '', image: '/images/sponsors/techzone.png', url: '', excludeWith: [''] },
];

function getRandomSponsors(sponsors, count = 2) {
  const shuffled = [...sponsors].sort(() => 0.5 - Math.random());

  for (let i = 0; i < shuffled.length; i++) {
    const selected = [shuffled[i]];
    for (let j = i + 1; j < shuffled.length; j++) {
      if (!selected[0].excludeWith.includes(shuffled[j].id)) {
        selected.push(shuffled[j]);
        return selected.slice(0, count);
      }
    }
  }

  return [shuffled[0]];
}

export default function SponsorBar() {
  const [selectedSponsors, setSelectedSponsors] = useState([]);

  useEffect(() => {
    setSelectedSponsors(getRandomSponsors(sponsors));
  }, []);

  return (
    <div className="sponsor-bar">
      {selectedSponsors.map(s => (
        <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer">
          <img src={s.image} alt={s.name} className="sponsor-banner" />
        </a>
      ))}
    </div>
  );
}